// eslint-disable-next-line no-unused-vars
import styled from 'styled-components';
import { lighten } from 'polished';

export const ScrollContainer = styled.div`
    height: ${({ height }) => height || 'auto'};
    margin-top: 1rem;
    overflow: auto;
    border: 1px solid rgba(67, 90, 111, 0.14);

    &::-webkit-scrollbar {
        background: transparent;
        width: 0.8rem;
    }

    &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 14px 14px transparent;
        border: solid 4px transparent;
    }

    &::-webkit-scrollbar-thumb {
        background: ${lighten(0.6, '#333333')};
        display: block;
        border-radius: 1rem;
        border: 0.2rem solid rgba(0, 0, 0, 0);
        background-clip: padding-box;
        -webkit-box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.025);
    }
    &::-webkit-scrollbar-button {
        width: 0;
        height: 0;
        display: none;
    }
    &::-webkit-scrollbar-corner {
        background-color: transparent;
    }
`;
